import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./style.css";
import Api from "../../services/api";
import { ToastContainer, toast } from "react-toastify";
import { changeIndexToNepali } from "../../utils";
const province_data = [
  "koshi",
  "madhesh",
  "bagmati",
  "gandaki",
  "lumbini",
  "karnali",
  "Sudurpashchim",
];
function MainDashboard() {
  const [ministryData, setMinistryData] = useState();
  const [user, setUser] = useState(
    JSON.parse(localStorage.getItem("user")).user
  );
  const [disabled, setDisabled] = useState(true);
  const [nextDisabled, setNextDisabled] = useState(true);

  const getMinistryData = async () => {
    try {
      let response = await Api.ministryAnswers({
        fiscal_year_id: user.fiscal_year_id,
        ministry_id: user.ministry_id,
        province_id: user.province_id
          ? user.province_id
          : sessionStorage.getItem("provinceId"),
      });
      if (response.code === 200) {
        setMinistryData(response.response);
        console.log("ministryData", response.response);
        if (response.response.cao_approved !== 0 || user.role_id === 6) {
          setNextDisabled(false);
        } else {
          setNextDisabled(true);
        }
      } else {
        toast.error(response.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (e) {
      toast.error(e, {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const handleCAOapprover = async () => {
    try {
      let response = await Api.submitCAOApprove({
        fiscal_year_id: user.fiscal_year_id,
        ministry_id: user.ministry_id,
        province_id: user.province_id
          ? user.province_id
          : sessionStorage.getItem("provinceId"),
      });
      if (response.code === 200 || response.code === 204) {
        toast.success(response.message, {
          position: toast.POSITION.TOP_CENTER,
        });
        getMinistryData();
      } else {
        toast.error(response.message, {
          position: toast.POSITION.TOP_CENTER,
        });
        getMinistryData();
      }
    } catch (e) {
      toast.error(e, {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  useEffect(() => {
    getMinistryData();
  }, []);

  useEffect(() => {
    ministryData && ministryData.data_completed === 1 && setDisabled(false);
  }, [ministryData]);
  return (
    <div
      style={{ height: "80vh" }}
      className="d-flex flex-column align-items-center justify-content-center"
    >
      {/* <p className="text-success h5 text-center">
        मन्त्रालयगत वित्तीय सुशासन लेखाजोखा प्रविष्ट गरी एकीकृत लेखाजोखा
        भर्नुहोस।
      </p> */}
      <div
        className="d-flex flex-column col-12 col-md-6"
        style={{ width: "100%" }}
      >
        {user.role_id !== 8 && user.role_id !== 12 && (
          <div className="card-layout mainCard">
            <p className="sub-heading">मन्त्रालयगत वित्तीय सुशासन लेखाजोखा</p>

            <div>
              <div>
                <Link
                  to={`/ministryEvaluation/${
                    province_data[sessionStorage.getItem("provinceId") - 1]
                  }`}
                >
                  <button
                    className="btn btn-primary"
                    // disabled={nextDisabled}
                  >
                    पृष्ठ प्रविष्ट गर्नुहोस्
                  </button>
                </Link>
              </div>
            </div>
          </div>
        )}
        {user.role_level === "ocmcm" && (
          <div className="card-layout mainCard">
            <p className="sub-heading">एकीकृत लेखाजोखा</p>
            <div className="d-flex justify-content-between">
              <div>
                <Link
                  to={`/provincialEvaluation/${
                    province_data[sessionStorage.getItem("provinceId") - 1]
                  }`}
                >
                  <button
                    className="btn btn-primary mr-2"
                    disabled={user.role_level !== "ocmcm"}
                  >
                    डाटा प्रविष्ट गर्नुहोस्
                  </button>
                </Link>
                {/* {user.role_id === 3 &&
                ministryData &&
                ministryData.cao_approved === 0 && (
                  <button
                    className="btn btn-success"
                    disabled={disabled}
                    onClick={() => handleCAOapprover()}
                  >
                    अनुमोदन गर्नुहोस्
                  </button>
                )} */}
              </div>
              {/* {ministryData && ministryData.cao_approved !== 0 && (
              <>
                <div className="d-flex pb-0">
                  <p className=" h4 text-success pb-0">स्कोर:</p>
                  <p className="h4 ml-3 pb-0" style={{ color: "#FFAC1C" }}>
                    {changeIndexToNepali(ministryData && ministryData.score)}
                  </p>
                </div>
                <div className="d-flex pb-0">
                  <p className=" h4 text-success pb-0"> स्वीकृत मिति:</p>
                  <p className="h4 ml-3 pb-0" style={{ color: "#FFAC1C" }}>
                    {changeIndexToNepali(
                      ministryData && ministryData.cao_approved
                    )}
                  </p>
                </div>
              </>
            )} */}
            </div>
          </div>
        )}
      </div>
      <ToastContainer />
    </div>
  );
}

export default MainDashboard;
